export default "/images/scissors.svg?37b72d07d22341b6cd06514784549a7b";